module.exports = __webpack_public_path__ + "static/img/info_2.a3b7485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2023/info_2.jpg
// module id = f88a
// module chunks = 4